export default "__VITE_ASSET__Ry_Al9_w__"